import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PaginaInicio.css";
import "./ZoomPage.css";
import Cabecera from "../Others/Cabecera";
import PiePagina from "../Others/PiePagina";
import BotonBarraInferior from "../Others/BotonBarraInferior";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import CourseRecordingsPanel from "../Others/CourseRecordingsPanel";
import { useData } from "./DataContext";
import { getAllLinks } from "./constants";
import {
  formatearFechaReunion,
  formatearHoraReunion,
  normalizarLinksZoom,
  obtenerProximaReunionCurso,
} from "../Others/zoomCourseUtils";

const barra_inferior = (
  <BarraInferior
    contenido={
      <>
        <BotonBarraInferior imagenSrc={require("../Assets/tablon.png")} texto="Foro de Discusión" redireccion="a-pagina-tablon" />
        <BotonBarraInferior imagenSrc={require("../Assets/contenido.png")} texto="Contenido" redireccion="a-pagina-content" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Ejercicios" redireccion="a-pagina-tareas" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Evaluación Diagnostica" redireccion="a-pagina-evaluacion" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Evaluación Final" redireccion="a-pagina-evaluacionfi" />
        <BotonBarraInferior imagenSrc={require("../Assets/zoom.png")} texto="Zoom" redireccion="a-pagina-zoom" />
      </>
    }
  />
);

const AdminZoomPage = () => {
  const { data, dataClase } = useData();
  const [proximaReunion, setProximaReunion] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const barra_superior = (
    <BarraSuperior
      texto_cabecera={dataClase?.nombre_clase || "Zoom del curso"}
      redireccion="admin-home"
      profile_redireccion="a-profile-page"
    />
  );

  const fetchProximaReunion = async () => {
    if (!dataClase?.matricula_clase) {
      setProximaReunion(null);
      setError("No fue posible identificar la materia seleccionada.");
      setCargando(false);
      return;
    }

    setCargando(true);
    setError("");

    try {
      const response = await axios.get(getAllLinks);
      const links = normalizarLinksZoom(response.data);
      const reunion = obtenerProximaReunionCurso(
        links,
        dataClase.matricula_clase,
      );
      setProximaReunion(reunion);
    } catch (requestError) {
      console.error("Error al obtener la próxima reunión de Zoom:", requestError);
      setProximaReunion(null);
      setError("No se pudo consultar la próxima reunión de Zoom.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchProximaReunion();
  }, [dataClase?.matricula_clase]);

  return (
    <div className="contenedor-pagina">
      <Cabecera contenidosuperior={barra_superior} contenidoInferior={barra_inferior} />

      <main className="student-zoom-page">
        <section className="student-zoom-panel">
          <div className="student-zoom-header">
            <div>
              <span className="student-zoom-eyebrow">Sesiones en vivo</span>
              <h1>Zoom · {dataClase?.nombre_clase || "Curso"}</h1>
              <p>Consulta la próxima reunión programada para esta materia.</p>
            </div>
          </div>

          {cargando && (
            <div className="student-zoom-state" role="status">
              <span className="student-zoom-spinner" aria-hidden="true" />
              <strong>Consultando Zoom...</strong>
              <p>Buscando la próxima sesión programada para este curso.</p>
            </div>
          )}

          {!cargando && error && (
            <div className="student-zoom-state student-zoom-state-error" role="alert">
              <span className="student-zoom-state-icon" aria-hidden="true">!</span>
              <strong>No pudimos consultar Zoom</strong>
              <p>{error}</p>
              <button type="button" onClick={fetchProximaReunion}>
                Intentar nuevamente
              </button>
            </div>
          )}

          {!cargando && !error && !proximaReunion && (
            <div className="student-zoom-state">
              <span className="student-zoom-state-icon student-zoom-state-icon-empty" aria-hidden="true">0</span>
              <strong>Sin reunión programada</strong>
              <p>No existe una próxima sesión de Zoom para esta materia.</p>
            </div>
          )}

          {!cargando && !error && proximaReunion && (
            <div className="student-zoom-grid">
              <article className="student-zoom-card">
                <div className="student-zoom-card-top">
                  <span className="student-zoom-camera" aria-hidden="true">Z</span>
                  <div>
                    <h2>{proximaReunion.nombre_clase || dataClase?.nombre_clase || "Clase"}</h2>
                    <span className="student-zoom-matricula">
                      {proximaReunion.matricula_clase || dataClase?.matricula_clase}
                    </span>
                  </div>
                  <span className="student-zoom-status">Próxima sesión</span>
                </div>

                <div className="student-zoom-details">
                  <div>
                    <span>Fecha</span>
                    <strong>{formatearFechaReunion(proximaReunion.fechaHora)}</strong>
                  </div>
                  <div>
                    <span>Hora</span>
                    <strong>{formatearHoraReunion(proximaReunion.fechaHora)}</strong>
                  </div>
                </div>

                <a
                  className="student-zoom-open"
                  href={proximaReunion.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Entrar a la reunión
                </a>
              </article>
            </div>
          )}
        </section>

        <CourseRecordingsPanel
          mode="admin"
          idClase={dataClase?.id_clase}
          accessToken={data?.access_token}
        />
      </main>

      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default AdminZoomPage;
